import { Component, Input } from '@angular/core';

/**
 * MDI의 Home (닫을 수 없는 첫 번째 탭)
 * <p>
 * np-mdi 안에 두면 그 안의 내용이 Home으로 고정된다. 탭은 아이콘 + 타이틀로 표시하고, 타이틀이 없으면 아이콘만 표시한다.
 * np-mdi 안에 없으면 Home이 없는 MDI가 된다.
 *
 * <pre>
 * &lt;np-mdi&gt;
 *     &lt;np-mdi-home title="WORK ORDER 관리" icon="fa-house"&gt;
 *         ... Home 내용 ...
 *     &lt;/np-mdi-home&gt;
 * &lt;/np-mdi&gt;
 * </pre>
 */
@Component({
  selector: 'np-mdi-home',
  standalone: true,
  template: '<ng-content />',
  styles: ':host { display: block; height: 100%; }',
  // title을 속성으로 넘기면 Home 내용 전체에 브라우저 툴팁이 뜨므로 속성은 지운다.
  host: { '[attr.title]': 'null' },
})
export class NpMdiHomeComponent {

  /** 탭에 표시할 타이틀. 없으면 아이콘만 표시한다. */
  @Input() title?: string;

  @Input() icon: string = 'fa-house';

}
